export default __webpack_public_path__ + "static/media/CapaImage.9b3e340b.svg";